// sfx.ts ↔ game/soundeffects.h (the Sfx id space) + game/misc.cpp:938-1138
// (the hardwired sfx-category variant tables + SfxFromCategory).
//
// The DEFINITIONS moved to sim/src/data/soundeffects.ts (the sim serializes a
// SfxFromCategory pick into the replicator's delayed kmidPlaySfx messages —
// Replicator.cpp:370-386 — and the per-unit consts tables carry the ids, so
// the sim layer owns them; the sim never imports client code). This module
// re-exports the id space for the UI/audio layers and keeps a delegating
// SfxFromCategory definition.
//
// VARIANT SELECTION IS ASYNC-RNG (sim-quirks B19): SfxFromCategory picks with
// GetAsyncRandom (game/misc.cpp:612 glAsyncSeed — ONE stream, shared with the
// sim's serialized picks via SimContext.rngAsync), DELIBERATELY out of
// lockstep sync; wiring the sync LCG here would desync multiplayer.

import type { Rng } from '../../../sim/src/math/rng.ts';
import { SfxFromCategory as SimSfxFromCategory } from '../../../sim/src/data/soundeffects.ts';

export * from '../../../sim/src/data/soundeffects.ts';

// game/misc.cpp:1127-1138 SfxFromCategory — pick a variant of the category with
// the ASYNC rng (misc.cpp:1133-1135: "We use GetAsyncRandom() to avoid
// disturbing the in-sync random number generator"; the pick is local-player
// cosmetic and differs per machine BY DESIGN — sim-quirks B19). rngAsync must
// be the glAsyncSeed instance (SimContext.rngAsync), NEVER the sync rng.
export function SfxFromCategory(sfxc: number, rngAsync: Rng): number {
  return SimSfxFromCategory(sfxc, rngAsync);
}
